import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImages1"><Path d="M3.68055 14.0831L6.52269 12.0819C7.3902 11.5376 8.54916 11.666 9.25861 12.3851C10.8443 13.9923 12.6827 15.4535 15.1875 15.4535C17.38 15.4535 18.8701 14.7271 20.2774 13.4653M3.5 3.5H20.5V20.5H3.5V3.5ZM17.5 9C17.5 10.3807 16.3807 11.5 15 11.5C13.6193 11.5 12.5 10.3807 12.5 9C12.5 7.61929 13.6193 6.5 15 6.5C16.3807 6.5 17.5 7.61929 17.5 9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImages1;
